import React from 'react';
import SEO from '../components/SEO';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2.5rem' }}>
    <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
      {title}
    </h2>
    <div
      className="body-medium"
      style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}
    >
      {children}
    </div>
  </div>
);

const MentionsLegales = () => {
  return (
    <>
      <SEO
        title="Mentions légales & Confidentialité | Harmonie Féminine"
        description="Mentions légales, conditions d'utilisation et politique de confidentialité du site du centre Harmonie Féminine par Nutri Centre Riviera."
        url="https://nutricentreriviera.ch/mentions-legales"
      />

      <div data-testid="page-mentions-legales" style={{ marginTop: '100px' }}>
        <section
          style={{
            background: 'var(--gradient-hero)',
            padding: '4rem 0',
            textAlign: 'center'
          }}
        >
          <div className="container">
            <h1 className="heading-hero" style={{ marginBottom: '1rem' }}>
              Mentions légales & Confidentialité
            </h1>
            <p className="heading-subtitle" style={{ maxWidth: '760px', margin: '0 auto' }}>
              Informations légales, politique de confidentialité et traitement de vos données
            </p>
          </div>
        </section>

        <section className="section" style={{ background: 'white' }}>
          <div className="container" style={{ maxWidth: '860px' }}>
            <Section title="Éditeur du site">
              <p style={{ marginBottom: '0.5rem' }}>
                <strong>Harmonie Féminine par Nutri Centre Riviera</strong>
              </p>
              <p style={{ marginBottom: '0.5rem' }}>
                Av. du Général-Guisan 26, 1800 Vevey, Suisse
              </p>
              <p style={{ marginBottom: '0.5rem' }}>
                Téléphone : <a
                  href="tel:+41767799302"
                  style={{ color: 'var(--accent-primary)' }}
                >
                  076 779 93 02
                </a>
              </p>
              <p>
                Email : <a
                  href="mailto:nutririviera@gmail.com"
                  style={{ color: 'var(--accent-primary)' }}
                >
                  nutririviera@gmail.com
                </a>
              </p>
            </Section>

            <Section title="Propriété intellectuelle">
              <p>
                L'ensemble du contenu du site (textes, images, logos, vidéos, structure) est
                protégé par le droit d'auteur. Toute reproduction, représentation, modification
                ou diffusion, totale ou partielle, sans autorisation écrite préalable, est
                interdite.
              </p>
              <p style={{ marginTop: '0.75rem' }}>
                <em>Hypnopraxie®</em> est une marque déposée du Dr Guy Chedeau.
              </p>
            </Section>

            <Section title="Protection des données personnelles (LPD / RGPD)">
              <p style={{ marginBottom: '1rem' }}>
                Nous respectons la Loi fédérale suisse sur la protection des données (LPD) et,
                lorsque applicable, le Règlement général européen sur la protection des données
                (RGPD).
              </p>

              <p style={{ marginBottom: '0.5rem', fontWeight: 600 }}>Données collectées</p>
              <p style={{ marginBottom: '1rem' }}>
                Nous ne collectons aucune donnée personnelle à l'insu des visiteurs via ce site.
                Les données que vous nous transmettez volontairement (téléphone, email lors d'une
                prise de contact ou d'une réservation) sont utilisées uniquement pour répondre à
                votre demande et assurer le suivi de votre accompagnement.
              </p>

              <p style={{ marginBottom: '0.5rem', fontWeight: 600 }}>Durée de conservation</p>
              <p style={{ marginBottom: '1rem' }}>
                Les données médicales sont conservées conformément à la législation suisse
                applicable (dossier médical : 10 ans minimum). Les données de contact simple sont
                conservées pour la durée nécessaire au traitement de votre demande.
              </p>

              <p style={{ marginBottom: '0.5rem', fontWeight: 600 }}>Vos droits</p>
              <p>
                Vous disposez d'un droit d'accès, de rectification, de suppression et
                d'opposition concernant vos données. Pour exercer ces droits, écrivez-nous à <a
                  href="mailto:nutririviera@gmail.com"
                  style={{ color: 'var(--accent-primary)' }}
                >
                  nutririviera@gmail.com
                </a>
                .
              </p>
            </Section>

            <Section title="Cookies et traceurs">
              <p>
                Ce site peut utiliser des cookies techniques strictement nécessaires à son
                fonctionnement. Si des cookies d'analyse d'audience (ex. Google Analytics) sont
                activés, un bandeau de consentement vous sera proposé afin de recueillir votre
                accord préalable, conformément à la réglementation en vigueur.
              </p>
            </Section>

            <Section title="Prise de rendez-vous en ligne">
              <p>
                La prise de rendez-vous est assurée par la plateforme externe <strong>OneDoc</strong>. Les données transmises lors de la réservation sont
                traitées par OneDoc selon leurs propres conditions. Consultez leur politique de
                confidentialité sur <a
                  href="https://www.onedoc.ch"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'var(--accent-primary)' }}
                >
                  onedoc.ch
                </a>
                .
              </p>
            </Section>

            <Section title="Responsabilité">
              <p>
                Les informations fournies sur ce site sont à visée informative et ne remplacent
                en aucun cas une consultation médicale. En cas de questions médicales,
                consultez un professionnel de santé. Nous nous efforçons d'offrir des
                informations précises et actualisées, mais ne pouvons garantir l'exactitude
                absolue de l'ensemble des contenus.
              </p>
            </Section>

            <Section title="Droit applicable et juridiction">
              <p>
                Le présent site est soumis au <strong>droit suisse</strong>. Tout litige relatif
                à son utilisation sera soumis aux tribunaux compétents du canton de <strong>Vaud</strong>.
              </p>
            </Section>

            <Section title="Contact">
              <p>
                Pour toute question relative à ces mentions légales ou à la protection de vos
                données, vous pouvez nous contacter à l'adresse <a
                  href="mailto:nutririviera@gmail.com"
                  style={{ color: 'var(--accent-primary)' }}
                >
                  nutririviera@gmail.com
                </a>
                .
              </p>
            </Section>

            <p
              className="body-small"
              style={{
                color: 'var(--text-muted)',
                fontStyle: 'italic',
                marginTop: '2rem',
                textAlign: 'center'
              }}
            >
              Dernière mise à jour : février 2026
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default MentionsLegales;
